import { Layout } from 'antd';
import styled, { css } from 'styled-components';
import { Content } from '../content';
import { Header } from '../header';
const SidebarTriggerWidth = 20;
export const Sidebar = styled(Layout.Sider).attrs({
    collapsedWidth: 24,
    collapsible: true,
    defaultCollapsed: true,
    width: 256
})`
  border-right: solid 1px var(--border-color);
  z-index: calc(var(--zindex-layer-09) + 1);
  position: absolute;
  top: 0;
  height: 100vh;

  ${({ $pinned })=>!$pinned && css`
      box-shadow: var(--shadow-08);
    `};

  & + ${Header} {
    padding-left: calc(var(--layout-02) + var(--layout-01)) !important;
    ${({ $pinned })=>$pinned && css`
        padding-left: calc(17 * var(--layout-01)) !important;
      `};
  }

  & + ${Header} + ${Content} {
    padding-left: var(--layout-02) !important;
    overflow: hidden;
    ${({ $pinned })=>$pinned && css`
        padding-left: calc(16 * var(--layout-01)) !important;
      `};
  }

  &.ant-layout-sider-collapsed .ant-layout-sider-children {
    opacity: 0;
    overflow: hidden;
    transition-delay: 0;
    width: 0;
    display: none;
  }

  &.ant-layout-sider-has-trigger {
    padding-bottom: 0;
  }

  .ant-layout-sider-children {
    overflow: auto;
    transition: opacity var(--animation-duration-medium) ease
      var(--animation-duration-medium);
  }

  .ant-layout-sider-trigger {
    background: transparent;
    position: absolute;
    top: 0;
    bottom: 0;
    right: -${SidebarTriggerWidth}px;
    width: ${SidebarTriggerWidth}px !important;
    height: auto;
    transition: opacity var(--animation-duration-fast) ease-in;

    &::before {
      content: '';
      width: 20px;
      height: 100%;
      position: absolute;
      left: 0;
      border-left: solid 2px transparent;
    }

    ${({ $pinned })=>$pinned && css`
        opacity: 0;

        &:hover {
          opacity: 1;

          &::before {
            cursor: ew-resize;
            border-left-color: var(--blue-40);
          }
        }
      `};

    div {
      background: var(--white-100);
      border-radius: var(--border-radius-curved);
      box-shadow: var(--shadow-08);
      height: 32px;
      line-height: 38px;
      position: absolute;
      right: calc(-1 * var(--layout-01) + ${SidebarTriggerWidth}px);
      top: var(--layout-04);
      width: var(--layout-03) !important;
      &:before {
        content: '';
        height: 32px;
        line-height: 38px;
        position: absolute;
        right: calc(var(--layout-01) - ${SidebarTriggerWidth}px);
        top: 0;
        width: ${SidebarTriggerWidth}px;
      }
    }
  }

  ${({ $pinned })=>$pinned && css`
      &:hover .ant-layout-sider-trigger {
        opacity: 1;
      }
    `};

  .ant-layout-sider-trigger svg {
    transition: transform linear var(--animation-duration-fast) ease;
  }

  .ant-layout-sider-trigger:hover svg {
    transform: scale(1.2);
  }
`;
